import { Box, Slider } from '@mui/material';
import { updateSurveyToFillQuestion } from '../../../../../../store/actions/dataEntryFillASurveyActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './SurveyRangeQuestion.css';

const SurveyRangeQuestion = ({ question, disabled, onChangeAlert }) => {
  const { id, config = {}, answer = [], error } = question;
  const { range = {} } = config;
  const { min, max, skip } = range;
  const dispatch = useDispatch();
  const [value, setValue] = useState(answer.length ? answer : [Number(min), Number(max)]);

  const handleChange = (evt, newValue) => {
    dispatch(
      updateSurveyToFillQuestion({
        questionId: id,
        newData: {
          answer: newValue || [Number(min), Number(max)],
          error: null
        }
      })
    );

    onChangeAlert();
  };

  useEffect(() => {
    setValue(answer.length ? answer : [Number(min), Number(max)]);
  }, [answer, max, min]);

  return (
    <>
      <Box className='survey-question__range'>
        <Slider
          className='survey-question__range-slider'
          getAriaLabel={() => 'Temperature range'}
          value={value}
          step={Number(skip)}
          onChange={handleChange}
          valueLabelDisplay='auto'
          disabled={disabled}
          min={Number(min) || 0}
          max={Number(max) || 100}
        />
        <Box className='survey-question__range-preview'>
          <span className='survey-question__range-label'>From</span>
          <div
            className={`survey-question__range-box ${disabled ? 'survey-question__range-box--disabled' : ''}`}
          >
            {value[0]}
          </div>
          <span className='survey-question__range-label'>To</span>
          <div
            className={`survey-question__range-box ${disabled ? 'survey-question__range-box--disabled' : ''}`}
          >
            {value[1]}
          </div>
        </Box>
        {error && <p className='survey-question__error-hint'>{error}</p>}
      </Box>
    </>
  );
};

export default SurveyRangeQuestion;
